export class InvoiceServiceRequest {
  newInvoiceNumber: string;
  serviceName: 'Redirecting'|'CargoReturn';
}
